import { render, staticRenderFns } from "./InvoiceCustomerIndex.vue?vue&type=template&id=6a5a300d"
import script from "./InvoiceCustomerIndex.vue?vue&type=script&lang=js"
export * from "./InvoiceCustomerIndex.vue?vue&type=script&lang=js"
import style0 from "./InvoiceCustomerIndex.vue?vue&type=style&index=0&id=6a5a300d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports